import Panel from "components/shared/Panel/Panel";
import styled from "styled-components";
import colours from "styles/colours";
import { resetButtonStyling } from "styles/commonStyles";
import fonts, { fontWeights } from "styles/fonts";

export const RemitListItem = styled.li`
  display: flex;
  list-style: none;
  margin: 10px;

  && {
    margin-top: 0;
  }
`;

export const InterconnectorInformation = styled.div`
  text-align: center;
  place-content: center;
  width: 150px;
  height: 150px; // match pie chart sizing
`;

export const ChartContainer = styled.div`
  position: relative;
  width: 150px;
  height: 150px;
  flex: 0 0 150px;
`;

export const DoughnutOutline = styled.div<{ $isVisible: boolean }>`
  position: absolute;
  inset: 0;
  border: 2px solid ${colours.highlightGrey};
  border-radius: 50%;
  pointer-events: none;
  opacity: ${({ $isVisible }): number => ($isVisible ? 1 : 0)};
  transition: all 0.3s;

  &::after {
    content: "";
    position: absolute;
    inset: 20px;
    border: 2px solid ${colours.highlightGrey};
    border-radius: 50%;
  }
`;

export const UnavailableCapacity = styled.span`
  text-align: center;
  font-weight: ${fontWeights.bold};
  font-size: ${fonts.medium};
  color: ${colours.crimsonRed};
`;

export const RemitMiniTilePanel = styled(Panel)`
  transition: all 0.3s;

  &.mini-tile:hover {
    border-left-color: ${colours.elexonPink};
    background-color: ${colours.lightHighlightGrey};
  }
`;

export const TileButton = styled.button`
  ${resetButtonStyling};

  display: flex;
  gap: 20px;
  padding: 10px 14px;
  font-size: 0.9em;
`;

export const LabelValueRow = styled.div`
  display: grid;
  grid-template-columns: 80px 1fr;
  column-gap: 24px;
  margin: 4px 0;
  white-space: nowrap;
`;

export const ValueText = styled.span`
  justify-self: start;
  color: ${colours.elexonBlack};
  font-size: 1rem;
  font-weight: ${fontWeights.normal};
`;
